import {
    Capacitor
} from '@capacitor/core';
import { Device } from '@capacitor/device';
import { PushNotifications } from '@capacitor/push-notifications';
import { LocalNotifications } from '@capacitor/local-notifications';

import { ParticipantDeviceToken } from '../models';
import Vue from 'vue';
import { DEVICE_TOKEN } from '../config/constants.js';

const setupPushNotifications = () => {
    LocalNotifications.requestPermissions().then(result => {
        PushNotifications.requestPermission().then(result => {
            if (result.granted) {
                // Register with Apple / Google to receive push via APNS/FCM
                PushNotifications.register();

                LocalNotifications.createChannel({
                    id: 'local_notifications',
                    name: 'In app notifications',
                    description: 'In app notifications',
                    importance: 5,
                    visibility: 1,
                    vibration: true,
                });

                // On success, we should be able to receive notifications
                PushNotifications.addListener('registration',
                    (token) => {
                        const body = {};
                        if (Capacitor.platform === 'ios') {
                            body.iosToken = token.value;
                        } else if (Capacitor.platform === 'android') {
                            body.androidToken = token.value;
                        }

                        Vue.$persistentStorage.set(DEVICE_TOKEN, token.value);

                        Device.getInfo()
                            .then(info => {
                                body.deviceInfo = JSON.stringify(info);
                                ParticipantDeviceToken
                                    .create({
                                        body,
                                    })
                                    .catch(() => { });
                            });
                    }
                );

                // Some issue with our setup and push will not work
                PushNotifications.addListener('registrationError',
                    (error) => {
                        // alert('Error on registration: ' + JSON.stringify(error));
                    }
                );

                // Show us the notification payload if the app is open on our device
                PushNotifications.addListener('pushNotificationReceived',
                    (notification) => {
                        //see: https://github.com/ionic-team/capacitor/issues/2261#issuecomment-647267061
                        const isPushNotification = !!notification.title || !!notification.body;

                        if (Capacitor.platform === 'android' && isPushNotification) {
                            LocalNotifications.schedule({
                                notifications: [{
                                    title: notification.title,
                                    body: notification.body,
                                    id: new Date().getUTCMilliseconds(),
                                    schedule: {
                                        at: new Date(Date.now() + 1000),
                                    },
                                    extra: notification.data,
                                    channelId: 'local_notifications',
                                }],
                            });
                        }
                    }
                );

                // Method called when tapping on a notification
                PushNotifications.addListener('pushNotificationActionPerformed',
                    (notification) => {
                        Vue.$router.onReady(() => {
                            const currentRoute = Vue.$router.currentRoute;

                            if (currentRoute.name !== 'home' && currentRoute.fullPath !== '/') {
                                Vue.$router.push({ name: 'home' });
                            } else if (currentRoute.matched && currentRoute.matched.length && currentRoute.matched[0].components) {
                                const component = currentRoute.matched[0].components.default;

                                if (component && typeof component.prefetch === 'function') {
                                    component.prefetch((callback) => callback(component));
                                }
                            }
                        });
                    }
                );
            } else {
                console.debug(result);
            }
        }).catch((error) => {
            console.debug(error);
        });
    });
};

export default {
    install(Vue) {
        Vue.$store.watch(
            state => state.user.accessToken,
            () => {
                if (Vue.$store.state.user.accessToken) {
                    setupPushNotifications();
                } else {
                    const cancelPush = PushNotifications.removeAllListeners();
                    const cancelLocal = LocalNotifications.removeAllListeners();

                    if (undefined !== cancelPush) {
                        cancelPush.catch(() => { });
                    }
                    if (undefined !== cancelLocal) {
                        cancelLocal.catch(() => { });
                    }
                }
            }
        );
    }
};
